import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { BuilderSliderSteps } from "@/enums/BuilderSliderSteps";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseBrowseInteriors',
  props: {
    houseInfo: {}
  },
  emits: ["selectSection"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const selectedSection = ref<BuilderSliderSteps | null>(null);

  const onSelectSection = (section: BuilderSliderSteps) => {
    selectedSection.value = section;
    emits("selectSection", section);
  };

const __returned__ = { props, emits, selectedSection, onSelectSection, onMounted, ref, get HouseDesignInterface() { return HouseDesignInterface }, get BuilderSliderSteps() { return BuilderSliderSteps } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})